import { OfferMappingApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useOfferMappingsAPI(): OfferMappingApi {
  return new OfferMappingApi(apiConfig);
}
